import {getDefaultSocialButtonsOptions, loadJssocials} from '@js/components/socialButtons';
import {merge} from 'lodash';
import {getUrlParameter, getUrlParamsString, replaceUrlParam} from '@js/helpers/location';
import moveAndHighlight from '@js/helpers/navigation';

export function initRankingRowShare($shareButtons) {
    const defaultOptions = getDefaultSocialButtonsOptions();
    $shareButtons.each(function () {
        const $closestRow = $(this).closest('.ranking-row');
        const organizationName = $closestRow.find('.ranking-organization-name').text();
        const organizationId = parseInt($closestRow.attr('data-vuz-id'), 10);
        const textParts = [$('title').text()];
        if (organizationName.trim()) {
            textParts.push(organizationName.trim());
        }
        let url = window.location.href;
        if (organizationId) {
            const path = url.split('?')[0];
            const previousOrganizationId = getUrlParameter('view_organization');
            let urlParamsString;
            if (previousOrganizationId) {
                urlParamsString = replaceUrlParam('view_organization', organizationId);
            } else {
                urlParamsString = getUrlParamsString();
                if (!urlParamsString) {
                    urlParamsString = '';
                }
                if (urlParamsString && urlParamsString.slice(-1) !== '&') {
                    urlParamsString += '&';
                }
                urlParamsString += `view_organization=${organizationId}`;
            }
            url = `${path}?${urlParamsString}`;
        }
        const socialButtonsOptions = merge(defaultOptions, {
            url,
            showLabel: true,
            text: textParts.join(' | '),
        });
        loadJssocials().then(() => {
            $(this).jsSocials(socialButtonsOptions);
        });
    });
}

export function highlightViewedOrganization() {
    const highlightOrganizationId = getUrlParameter('view_organization');
    const $target = $(`.ranking-row[data-vuz-id="${highlightOrganizationId}"]`);
    if (highlightOrganizationId && $target.length) {
        const fixedHeaderOffset = $target.is('tr')
            ? $('.ranking-table').find('thead').height()
            : 0;
        moveAndHighlight($target, 'highlight-bg', fixedHeaderOffset);
    }
}
